import React from 'react';
import { useStyles } from './styles';
import { textConfig } from '../../global/text';
import { upgradePlan } from '../../global/utils/plan';

const QuotaReachedOneLine = ({ plan }) => {
  const classes = useStyles();

  return (
    <div>
      <span>{textConfig.specificPage.quotaReached.part1}</span>
      {plan.available.length > 0 && (
        <>
          <span
            className={classes.upgradeLabel}
            onClick={() => {
              upgradePlan(plan.available);
            }}
          >
            {textConfig.specificPage.quotaReached.upgrade}
          </span>
          <span>{textConfig.specificPage.quotaReached.part2}</span>
        </>
      )}
    </div>
  );
};

export default QuotaReachedOneLine;
